module.exports = __webpack_public_path__ + "media/img/frontend_application/venue/email-icon-1259635a9bd0e5f2212747af2a9f4e8f.png";